<template>
  <div v-loading="loading" class="main-frame" :element-loading-text="$t('commonInfo.Loading')">
    <el-container>
      <el-header class="banner-head">
        <div class="head-info">
          <el-row>
            <el-col style="text-align: left" :span="24">
              <el-page-header
                style="color: #333333"
                :title="$t('commonInfo.Back')"
                @back="goBack"
                :content="$t('commonInfo.CodeList')"
              ></el-page-header>
            </el-col>
          </el-row>
        </div>
      </el-header>

      <el-main>
        <el-form class="search_table_info" ref="form" :inline="true" :model="form">
          <el-form-item :label="$t('commonInfo.status') + ':'">
            <el-select
              v-model.trim="check_status"
              clearable
              :placeholder="$t('commonInfo.pleaseSelect')"
              :loading-text="$t('commonInfo.Loading')"
            >
              <el-option
                v-for="item in checked_status_list"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('commonInfo.keyWord') + ':'">
            <el-input
              v-model.trim="search_key"
              clearable
              size="medium"
              :placeholder="$t('commonInfo.pleaseEnterKey')"
            ></el-input>
          </el-form-item>
          <el-form-item style="float: right">
            <el-button type="primary" @click="query_code_list">
              {{
              $t("storeMessage.Search")
              }}
            </el-button>
            <el-button type="primary" @click="export_excel">
              {{
              $t("storeMessage.DownloadTheFile")
              }}
            </el-button>
          </el-form-item>
        </el-form>
        <!-- 表格渲染 -->
        <el-table :data="scratch_code_list" style="width: 100%" strip border default-expand-all>
          <el-table-column label="#" width="180" align="center">
            <template slot-scope="scope">
              <p style="font-weight: bold">{{ scope.$index + 1 }}</p>
            </template>
          </el-table-column>

          <el-table-column prop="checked_times" :label="$t('scratchCode.checkTime')" align="center"></el-table-column>
          <el-table-column
            prop="scratch_code"
            :label="$t('scratchCode.scratchCode')"
            align="center"
          ></el-table-column>
          <el-table-column :label="$t('storeMessage.Operation')" align="center">
            <template slot-scope="scope">
              <el-button
                size="small"
                type="primary"
                @click="edit_model(scope.row)"
              >{{ $t("commonInfo.viewDetail") }}</el-button>
              <!-- <el-button
                size="small"
                type="primary"
                @click="remove_model(scope.row)"
              >
                {{ $t("storeMessage.Delete") }}
              </el-button>-->
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer class="footer_info">
        <el-pagination
          style="margin-top: 15px"
          background
          layout="sizes,prev, pager, next, jumper"
          :page-sizes="[20, 50, 100, 150]"
          :page-size="page_size"
          @size-change="handleSizeChange"
          :pager-count="9"
          :total="page_total"
          :current-page="page_number"
          @current-change="currentChangeOnclick"
        ></el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      loading: false,
      checked_status_list: [
        {
          id: 0,
          name: "所有",
          tag: ""
        },
        {
          id: 1,
          name: "已核销",
          tag: "success"
        },
        {
          id: 2,
          name: "未核销",
          tag: "warning"
        }
      ],
      form: {},
      scratch_code_list: [], //刮刮码表格
      search_key: "",
      check_status: "",
      // 分页部分
      page_total: 0,
      page_size: 20,
      page_number: 1
    };
  },
  watch: {},
  computed: {},
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    query_code_list() {
      let _me = this;
      _me.loading = true;
      let params = {
        key: _me.search_key,
        page_number: _me.page_number,
        page_size: _me.page_size,
        sort_fields: "",
        checked_status: _me.check_status
      };
      _me.$common
        .httpPost("/api/scratch/admin/code/find/list", params)
        .then(res => {
          _me.loading = false;
          if (res.code == 1000000) {
            if (res.data.array) {
              _me.scratch_code_list = res.data.array;
              _me.page_total = res.data.total;
            } else {
              _me.scratch_code_list = [];
            }
          } else {
            _me.$message.error(res.message);
          }
        })
        .catch(err => {
          _me.loading = false;
          if (err.code == 1000009 || err.code == 1000007) {
            this.$router.push("sign-in");
          }
          _me.$message.error(err.message);
        });
    },
    // 导出刮刮码列表
    export_excel() {
      this.loading = true;
      let _me = this;
      let params = {
        key: _me.search_key,
        page_number: _me.page_number,
        page_size: -1,
        page_id: -1,
        checked_status: _me.check_status
      };
      _me.$common
        .httpPostBlob("/api/scratch/admin/code/export/list", params)
        .then(res => {
          let content_disposition = decodeURI(
            res.headers["content-disposition"]
          ); //解码后获取文件名字
          content_disposition = content_disposition.substring(
            content_disposition.indexOf("utf-8") + 7
          );
          res = res.data;
          _me.loading = false;
          if (res && res.size > 0) {
            const blob = new Blob([res]);
            // const fileName = "刮刮码.xlsx"; //下载文件名称
            const elink = document.createElement("a");
            elink.download = content_disposition;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
          } else {
            _me.$message.error(res.message);
          }
        })
        .catch(err => {
          _me.loading = false;
          if (err.code == 1000009 || err.code == 1000007) {
            _me.$router.push("sign-in");
          }
          _me.$message.error(err.message);
        });
    },
    handleSizeChange(val) {
      this.page_size = val;
      this.query_code_list();
    },
    // 切换页码
    currentChangeOnclick(number) {
      this.page_number = number;
      this.query_code_list();
    },
    // 编辑
    edit_model(scope_params) {
      this.$router.push("edit-scratch-code-detail?id=" + scope_params.id);
    }
  },
  created() {},
  mounted() {
    this.query_code_list();
  }
};
</script>
<style  scoped>
</style>